/* Global Helpers */

// Function to make IE9+ support forEach:
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

/* Mobile Menu Toggling */
const mobileMenuToggle = document.getElementById('mobileMenuToggle');
const mobileMenuClose = document.getElementById('mobileMenuClose');
const mainMenu = document.getElementById('mainMenu');

mobileMenuToggle.addEventListener('click', (e) => {
  e.preventDefault();
  mainMenu.classList.toggle('open');
});

mobileMenuClose.addEventListener('click', (e) => {
  e.preventDefault();
  mainMenu.classList.remove('open');
});

/* Drop down menus */
let menuTimer;
const topLevelMenuButtons = document.querySelectorAll('.top-level button');
const allMenus = document.querySelectorAll('.top-level li > div');
const menuMask = document.getElementById('menuMask');

function setupMenus(mq) {
  function topLevelMouseOver(e) {
    e.preventDefault();
    // Hide the other menus
    allMenus.forEach((menu) => {
      menu.classList.remove('open');
    });
    // Show this menu
    const siblingMenu = e.currentTarget.nextElementSibling;
    siblingMenu.classList.add('open');
    menuMask.classList.add('open');
    // Clear any menu close timers
    clearTimeout(menuTimer);
  }
  function topLevelMouseOut(e) {
    e.preventDefault();
    const siblingMenu = e.currentTarget.nextElementSibling;
    menuTimer = setTimeout(() => {
      // Close menu after half second timer,
      // allows user to roll beyond menu and back without it closing
      siblingMenu.classList.remove('open');
      menuMask.classList.remove('open');
    }, 500);
  }
  function topLevelClick(e) {
    e.preventDefault();
    const siblingMenu = e.currentTarget.nextElementSibling;
    siblingMenu.classList.toggle('open');
    menuMask.classList.toggle('open');
  }
  function menuMouseOver(e) {
    e.preventDefault();
    clearTimeout(menuTimer);
  }
  function menuMouseOut(e) {
    e.preventDefault();
    const target = e.currentTarget;
    menuTimer = setTimeout(() => {
      target.classList.remove('open');
      menuMask.classList.remove('open');
    }, 500);
  }
  function menuMaskMouseOver(e) {
    e.preventDefault();
    // Hide all menus
    allMenus.forEach((menu) => {
      menu.classList.remove('open');
    });
    menuMask.classList.remove('open');
  }

  if (mq.matches) {
    // Desktop menu stuff
    topLevelMenuButtons.forEach((button) => {
      // Rollover open relevant menu
      button.addEventListener('mouseover', topLevelMouseOver);
      // Rollover close relevant menu
      button.addEventListener('mouseout', topLevelMouseOut);
      button.removeEventListener('click', topLevelClick);
    });

    // Ensure menus don't close when mouse on the menu rather than button
    allMenus.forEach((menu) => {
      menu.addEventListener('mouseover', menuMouseOver);
      menu.addEventListener('mouseout', menuMouseOut);
    });

    // Hide the menus straigh away when move into the mask
    menuMask.addEventListener('mouseover', menuMaskMouseOver);
  } else {
    // Mobile menu stuff
    topLevelMenuButtons.forEach((button) => {
      // Click mainly for mobile menu and touch screen
      button.addEventListener('click', topLevelClick);
      button.removeEventListener('mouseover', topLevelMouseOver);
      button.removeEventListener('mouseout', topLevelMouseOut);
    });

    allMenus.forEach((menu) => {
      menu.removeEventListener('mouseover', menuMouseOver);
      menu.removeEventListener('mouseout', menuMouseOut);
    });
    menuMask.removeEventListener('mouseover', menuMaskMouseOver);
  }
}
const desktopMediaQuery = window.matchMedia('(min-width: 1025px)');
setupMenus(desktopMediaQuery);
desktopMediaQuery.addListener(setupMenus);

/* HTML include requestor */
function fetchHtmlInclude(path, callback) {
  const request = new XMLHttpRequest();
  request.open('GET', path);
  request.send();

  request.addEventListener('loadend', () => {
    if (request.status === 200) {
      if (request.responseText.trim() !== '') {
        callback(request.responseText);
      } else {
        callback(false);
      }
    }
  });
}

/* Grab latest USP callouts */
fetchHtmlInclude('https://www.arenaflowers.com/contentful/usp-include.html', (html) => {
  if (html !== false) {
    const uspBarStatic = document.querySelector('header .upper-nav .static').cloneNode(true);
    const uspBar = document.querySelector('header .upper-nav');
    uspBar.innerHTML = html;
    uspBar.appendChild(uspBarStatic);
  }
});

/* Grab latest announcement bar */
const announcementBar = document.getElementById('announcementBar');
if (announcementBar) {
  fetchHtmlInclude('https://www.arenaflowers.com/contentful/announcement.html', (html) => {
    if (html !== false) {
      announcementBar.innerHTML = html;
      announcementBar.classList.remove('hide');
    }
  });
}
